import http from '@os-web/http';
import {
  __DEFAULT_CHANNEL__,
  __DEFAULT_PLATFORM__,
  __DEV__,
  STORAGE_CHANNEL_KEY,
  STORAGE_PLATFORM_KEY,
  STORAGE_SCHANNEL_KEY,
  STORAGE_SW_TOKEN_KEY,
  STORAGE_TOKEN_KEY,
} from '@os-web/const';
import queryString from 'query-string';

export interface EnvInitOptions {
  appTitleBar?: boolean;
  channel?: string | null;
  platform?: string | null;
  wechatAuthorization?: boolean;
}

function toStorageValue(value: unknown) {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
}

function notEmptySetStorage(key: string, value: unknown) {
  if (value === null || value === undefined || value === '') return;
  const storageValue = toStorageValue(value);
  if (!storageValue) return;
  localStorage.setItem(key, storageValue);
}

/**
 * 初始化移动端调试面板。
 */
export async function initVConsole() {
  if (!__DEV__ && !/isShowVConsole=1/.test(location.search)) {
    return;
  }

  const eruda = (await import('eruda')).default;

  eruda.init();
  window.vConsole = eruda;
}

export const defaultEnvOptions = {
  appTitleBar: true,
  channel: null,
  platform: null,
  wechatAuthorization: false,
} satisfies EnvInitOptions;

export function appEnvInit(options?: EnvInitOptions) {
  return h5EnvInit(options);
}

export function wechatMpEnvInit(options?: EnvInitOptions) {
  return h5EnvInit(options);
}

export function wechatEnvInit(options?: EnvInitOptions) {
  return h5EnvInit(options);
}

export async function h5EnvInit(options?: EnvInitOptions) {
  const normalizedOptions = {
    ...defaultEnvOptions,
    ...options,
  };

  await handleQueryToken();

  const query = queryString.parse(location.search);
  const channel =
    query.channel ||
    normalizedOptions.channel ||
    localStorage.getItem(STORAGE_CHANNEL_KEY) ||
    __DEFAULT_CHANNEL__;
  const schannel = query.schannel || localStorage.getItem(STORAGE_SCHANNEL_KEY);
  const platform =
    normalizedOptions.platform || query.platform || import.meta.env.VITE_APP_PLATFORM;

  notEmptySetStorage(STORAGE_PLATFORM_KEY, platform);
  notEmptySetStorage(STORAGE_CHANNEL_KEY, channel);
  notEmptySetStorage(STORAGE_SCHANNEL_KEY, schannel);
}

async function handleQueryToken() {
  const { url, query } = queryString.parseUrl(location.href);

  function delSensitiveParams(data: Record<string, unknown>) {
    const nextQuery: Record<string, string> = {};

    for (const [key, value] of Object.entries(data)) {
      if (['token', 'uc_token', 'sw_token'].includes(key)) continue;
      const storageValue = toStorageValue(value);
      if (storageValue) nextQuery[key] = storageValue;
    }

    ['token', 'uc_token', 'sw_token'].forEach((key) => {
      delete nextQuery[key];
    });
    return nextQuery;
  }

  function reload() {
    const newUrl = queryString.stringifyUrl({ url, query: delSensitiveParams(query) });
    location.replace(newUrl);
    throw new Error('去除 token，重载页面...');
  }

  let clear = false;

  if (query.token) {
    clear = true;
    notEmptySetStorage(STORAGE_TOKEN_KEY, query.token);
  }

  if (query.sw_token) {
    clear = true;
    notEmptySetStorage(STORAGE_SW_TOKEN_KEY, query.sw_token);
  }

  if (query.uc_token) {
    clear = true;
    const data = {
      token: query.uc_token,
      platform: __DEFAULT_PLATFORM__,
      channel: query.channel || localStorage.getItem(STORAGE_CHANNEL_KEY) || __DEFAULT_CHANNEL__,
    };

    if (query.schannel) {
      Object.assign(data, { schannel: query.schannel });
    }

    const res = await http
      .post<unknown, { token?: string }>('/api/login/union', data)
      .catch((error) => {
        console.error(error);
      });
    notEmptySetStorage(STORAGE_TOKEN_KEY, res?.token);
  }

  if (clear) reload();
}

export async function envInit(options?: EnvInitOptions) {
  return h5EnvInit(options);
}
